import { render, staticRenderFns } from "./dateFilter.vue?vue&type=template&id=54ccd440"
import script from "./dateFilter.vue?vue&type=script&lang=js"
export * from "./dateFilter.vue?vue&type=script&lang=js"
import style0 from "./dateFilter.vue?vue&type=style&index=0&id=54ccd440&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports